import React from 'react'
import { useTranslation } from 'react-i18next'
import Spacing from '../componenets/UI/Spacing'
import { Helmet } from 'react-helmet'

export default function FutureMineralsCleanEnergyGlobalDemandPage() {
  const { t } = useTranslation()
  return (
    <div className="app-container px-8 lg:px-0">
      <Helmet>
        <title>{`APFM | ${t('GLOBAL_DEMAND')}`}</title>
      </Helmet>
      <Spacing />
      <h2
        data-aos={`fade-down`}
        data-aos-delay={100}
        className="mb-4 text-2xl font-black"
      >
        {t('GLOBAL_DEMAND')}
      </h2>
      <div
        data-aos={`fade-up`}
        data-aos-delay={100}
        className="border-muted-300 mb-4 w-full border-2"
      >
        <iframe
          title={t('GLOBAL_DEMAND')}
          className="h-96 w-full md:h-[600px] lg:h-[650px] xl:h-[728px]"
          src={t('CLEAN_ENERGY_GLOBAL_DEMOND_POWER_PI')}
        />
      </div>
      <div
        data-aos={`fade-up`}
        data-aos-delay={100}
        className="relative flex flex-col"
      >
        <div className="font-bold">{t('SOURCE')}</div>
        <p>{t('INDUSTRIES_GLOBAL_DEMOND_SOURCE_POWER_PI')}</p>
      </div>
    </div>
  )
}
